import React from 'react';
import Picture from "../../../shared/components/Picture";
import { formatImageUrl } from "../../../shared/utils";
import MatchData from "../../../mls-match-list/components/MatchData";
import { useReactAppState } from "../../../shared/containers/utils";
import { trackMatchHubClick } from '../../../../libraries/_modules/tracking/helpers';
import { useMatchData } from '../../../mls-match-list/utils';

function HubMatchClub({ clubData, isHome, summary }) {
  const { mediaQueries, urlList, isLeague } = useReactAppState();
  const { baseUrl } = urlList || {};
  const { slug, status, competition, winnerStatus } = useMatchData();
  const {
    isHomeWinner,
    isAwayWinner
  } = winnerStatus || {};

  const { isMediumLargeMin } = mediaQueries || {};
  const { abbreviation, fullName, shortName, logoColorUrl } = clubData || {};

  const clubSlug = clubData?.slug;
  const availableName = shortName ? shortName : fullName;
  const isClubWinner = isHome ? isHomeWinner : isAwayWinner;
  const isHomeModifierClass = `mls-o-match-strip__club--${isHome ? 'home' : 'away'}`;
  const isWinnerModifierClass = `${isClubWinner ? 'mls-o-match-strip__club--winner' : ''}`;

  if (!abbreviation && !availableName) {
    return null;
  }

  const { highQuality } = logoColorUrl ? formatImageUrl(logoColorUrl, { format: "w_128,h_128,c_pad", extension: "f_png" }) : {};

  const handleClick = () => {
    trackMatchHubClick({
      clickType: 'club',
      match: slug,
      matchState: status?.abbreviation,
      competition: competition.shortName,
      clubName: availableName
    });
  };

  return (
    <div className={`mls-o-match-strip__club ${isHomeModifierClass} ${isWinnerModifierClass}`}>
      <div className="mls-o-match-strip__club-name" onClick={handleClick}>
        <span className="mls-o-match-strip__club-logo">
          {
            isLeague && clubSlug ?
              (
                <a aria-label={availableName} titlel={availableName} href={`${baseUrl}/clubs/${clubSlug}`}>
                  <Picture
                    src={highQuality}
                    role="presentation" />
                </a>
              )
              :
              <Picture
                src={highQuality}
                role="presentation" />
          }
        </span>
        {
          isMediumLargeMin
            ? (
              <span className="mls-o-match-strip__club-short-name">
                {
                  isLeague && clubSlug ?
                  (
                    <a title={availableName} href={`${baseUrl}/clubs/${clubSlug}`}>
                      {availableName}
                    </a>
                  )
                  :
                  availableName
                }
                <MatchData isHome={isHome} summary={summary} />
              </span>
            )
            :
            (
              <span className="mls-o-match-strip__club-abbreviation">
                {
                  isLeague && clubSlug ?
                    (
                      <a alt={abbreviation} href={`${baseUrl}/clubs/${clubSlug}`}>
                        {abbreviation}
                      </a>
                    )
                    :
                    abbreviation
                }
              </span>
            )
        }
      </div>
    </div>
  );
}

// eslint-disable-next-line no-func-assign
HubMatchClub = React.memo(HubMatchClub);

export default HubMatchClub;
